
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import ProductDescription from '../../components/feature/ProductDescription';
import VideoFeedback from '../../components/feature/VideoFeedback';
import Benefits from '../../components/feature/Benefits';
import Guarantee from '../../components/feature/Guarantee';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalOffer from '../../components/feature/FinalOffer';
import Footer from '../../components/feature/Footer';
import MobileBottomBar from '../../components/feature/MobileBottomBar';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ProductDescription />
      <VideoFeedback />
      <Benefits />
      <Guarantee />
      <Testimonials />
      <FAQ />
      <FinalOffer />
      <Footer />
      <MobileBottomBar />
    </div>
  );
}
